var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.isEmpty)?_c('span',{key:"empty-period"},[_vm._v("\n    "+_vm._s(_vm.emptyText)+"\n  ")]):_c('span',{key:"has-period"},[_c('span',{staticClass:"start"},[_vm._v(_vm._s(_vm.startText))]),_c('span',{staticClass:"dash px-1"},[_vm._v(_vm._s(_vm.dash))]),_c('span',{staticClass:"end"},[_vm._v(_vm._s(_vm.endText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }